/**
 * Creates hierarchical menu based on WordPress menu.
 * @link https://www.wpgraphql.com/docs/menus/#hierarchical-data
 */
import React, { useEffect } from "react"
import UniversalLink from "§/src/utils/UniversalLink"
import TopNavMobile from "./top-nav-mobile"
import classNames from "classnames"
// import { normalizePath } from "../../../utils/functions";

import { FlatListToHierarchical } from "§/src/utils/FlatListToHierarchical"
import ButtonClose from "§/src/components/atoms/buttons/button-close"
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"

/**
 * Internal dependencies.
 */
import "./_main-nav.scss"
import { mainNavScripts } from "./main-nav-scripts"

// Assets
import MainLogo from "§/src/images/svg/gefran-logo.svg"
import SearchIcon from "§/src/images/svg/search.svg"

// Language
import { useTranslation } from "react-i18next"

const FourthWall = ({wpCatMenu}) => {
  const { t } = useTranslation()

  return (
    <ul className="catmenuplus">
      <li>
        <a
          target="_self"
          className="dropdown-item nav-link"
          href="#"
        >
          {t("Altro")}
        </a>

        <ul className="subcat-links">

          {wpCatMenu && wpCatMenu.map((menuItem, index) => {
            return(
              <li key={index}>
                <UniversalLink
                  className="small-link h7"
                  to={ menuItem.uri }
                  activeClassName="active"
                  key={ index }
                >
                  {menuItem.title}
                </UniversalLink>
              </li>
            )
          })}

        </ul>

      </li>
    </ul>
  )
}

const SingleMenuColumn = ({
  liClass,
  linkClass,
  menuItem,
  menuIndex,
  dropContainerClass,
  allCategories,
  wpCatMenu
}) => {
  return (
    <li className={liClass}>
      {menuItem.children.length > 0 ? (
        <a
          href="#"
          className={linkClass}
          role="button"
          data-bs-toggle="dropdown"
          data-bs-auto-close="outside"
          aria-expanded="false"
          target={menuItem.target || '_self'}
        >
          {menuItem.title}
        </a>
      ) : (
        <UniversalLink
          className={linkClass}
          to={menuItem.uri}
          activeClassName="active"
          target={menuItem.target || '_self'}
        >
          {menuItem.title}
        </UniversalLink>
      )}

      {
        // if is maincategory, print subcategories
        menuItem.cssClasses.includes("maincat") &&
          allCategories?.map((cats, index) => {
            if (cats.uri === menuItem.path) {
              cats?.wpChildren?.nodes?.sort((a, b) => a.termOrder - b.termOrder)
              return (
                <ul className="subcat-links" key={index}>
                  {cats?.wpChildren?.nodes?.map((subcat, index) => {
                    // Exclude categories with only EOP products
                    const products = subcat.products.nodes
                    const productsCount = products.length
                    const eopProducts = products.filter(
                      i => i.AcfCptProduct.badge === "eop"
                    ).length

                    if (eopProducts < productsCount) {
                      return (
                        <li key={index}>
                          <UniversalLink
                            className="small-link h7"
                            to={subcat.link}
                            activeClassName="active"
                          >
                            {subcat.name}
                          </UniversalLink>
                        </li>
                      )
                    }
                  })}
                </ul>
              )
            }
          })
      }

      {menuItem.children.length > 0 && (
        <div className={dropContainerClass}>
          <MenuLoop
            allCategories={allCategories}
            menuItems={menuItem.children}
            menuIndex={menuIndex + 1}
            menuClass={menuItem.cssClasses}
            wpCatMenu={wpCatMenu}
          ></MenuLoop>
        </div>
      )}
    </li>
  )
}

const SingleMenu = ({ menuItems, menuIndex, allCategories, wpCatMenu }) => {
  return (
    <React.Fragment>
      {menuItems.map((menuItem, index) => {

        var liClass = menuItem.cssClasses.join(' ')

        if (menuItem.children.length > 0 && menuItem.parentId) {
          var liClass = liClass + " dropend"
        } else if (menuItem.children.length > 0 && !menuItem.parentId) {
          var liClass = liClass + " dropdown"
        } else {
          var liClass = liClass
        }

        var linkClass =
          menuItem.children.length > 0
            ? "dropdown-toggle nav-link"
            : "dropdown-item nav-link"
        var dropContainerClass = "drop-container" // main drop-container

        if (!menuItem.parentId) {
          liClass = liClass + " nav-item"
          linkClass = linkClass + " main-dt" // main dropdown-toggle
          dropContainerClass = dropContainerClass + " main-dc" // main drop-container
        }

        return (
          <SingleMenuColumn
            key={index}
            liClass={liClass}
            linkClass={linkClass}
            menuItem={menuItem}
            menuIndex={menuIndex}
            dropContainerClass={dropContainerClass}
            allCategories={allCategories}
            wpCatMenu={wpCatMenu}
          />
        )
      })}
    </React.Fragment>
  )
}

// NAV WALKER
const MenuLoop = ({ menuItems, menuIndex, allCategories, wpCatMenu, menuClass }) => {
  const classes = classNames({
    "dropdown-menu": menuIndex !== 0,
    "navbar-nav": menuIndex === 0,
  })

  return (

    <ul className={classes}>
      {menuClass?.includes('bigcatmenu') ? (
          <li className="d-flex flex-column">
            <ul className="list-unstyled">
              <SingleMenu
                menuItems={menuItems}
                menuIndex={menuIndex}
                allCategories={allCategories}
                wpCatMenu={wpCatMenu}
              />
            </ul>
            <FourthWall
              wpCatMenu={wpCatMenu}
            />
          </li>
      ) : (
        <SingleMenu
          menuItems={menuItems}
          menuIndex={menuIndex}
          allCategories={allCategories}
          wpCatMenu={wpCatMenu}
        />
      )}
    </ul>
  )
}

const MainNav = props => {
  const { t } = useTranslation()
  const { wpMenu: { nodes }, } = props
  const menuCats = props.categories.nodes
  const wpCatMenu = props?.wpCatMenu?.nodes
  let menuIndex = 0

  const headerMenu = FlatListToHierarchical(nodes, {
    idKey: "id",
    childrenKey: "children",
    parentKey: "parentId",
  })

  const rawData = props.rawData
  const langMenu = rawData.langMenu
  const topMenu = rawData.topMenu
  const socialMenu = rawData.socialMenu
  const general = rawData.wp.generalSettings

  useEffect(() => {
    mainNavScripts()
  }, []) //notice the empty array here - Runs only on the first render

  return (
    <nav id="main-nav" className="navbar navbar-expand-lg bg-light">
      <div className="container-max">
        <UniversalLink
          className="navbar-brand col-auto py-3 d-block"
          rel="home"
          to="/"
          title={props.title}
          tagline={props.tagline}
        >
          <MainLogo />
        </UniversalLink>

        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          {headerMenu.length > 0 && (
            <MenuLoop
              allCategories={menuCats}
              wpCatMenu={wpCatMenu}
              menuItems={headerMenu}
              menuIndex={menuIndex}
            ></MenuLoop>
          )}
        </div>

        <div id="search-nav" className="input-group input-group-sm ms-auto" onClick={props.onSearchClick}>
          <span className="input-group-text rounded-pill">
            <SearchIcon></SearchIcon>
            <div className="input-hidden-label" aria-hidden="true">
              {t("Cerca")}
            </div>
          </span>
        </div>

        <div id="close-algolia" className="close-button position-relative" onClick={props.onCloseClick}>
          <button
            type="button"
            className="btn-close m-0"
            aria-label="Close"
          ></button>
        </div>

        <button
          className="navbar-toggler hamburgher px-0 d-lg-none"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#mobileNavbar"
          aria-controls="mobileNavbar"
          aria-label="Toggle navigation"
        >
          <span className="first"></span>
          <span className="second my-1"></span>
          <span className="third"></span>
        </button>

        <div
          className="offcanvas offcanvas-start d-lg-none"
          tabIndex="-1"
          id="mobileNavbar"
          aria-labelledby="mobileNavbarLabel"
        >
          <div className="offcanvas-header pt-2 pb-4">
            <div className="navbar-brand col-auto py-3 d-block">
              <MainLogo />
            </div>
            <div className="menu-navigator">
              <ButtonArrow
                id="mobNavBack"
                dir="start"
                text={t("indietro")}
                className="px-0 text-gray"
              />
            </div>
            <button
            type="button"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            className="ms-auto btn btn-svg close-menu"
            >
              <ButtonClose/>
            </button>
          </div>
          <div id="mobile-container">
            {headerMenu.length > 0 && (
              <MenuLoop
                wpCatMenu={wpCatMenu}
                allCategories={menuCats}
                menuItems={headerMenu}
                menuIndex={menuIndex}
              ></MenuLoop>
            )}
            <TopNavMobile
              lang={props.lang}
              langReplace={props.langReplace}
              langMenu={langMenu}
              topMenu={topMenu}
              socialMenu={socialMenu}
              general={general}
            />
          </div>
        </div>
      </div>
    </nav>
  )
}

export default MainNav
